import { Image } from "@/icons/Image";
import { RichText } from "@/sections";
import { Link } from "@anoki/fse-common/dist";
import React from "react";
import { ArrowLink } from "../ArrowLink";
import { SectionHeading } from "../Section";
import "./CardPreview.scss";

export enum CardPreviewVariant {
  WITH_TOPIC_DATE = "withTopicDate",
  NO_TOPIC_DATE = "noTopicDate",
}

export interface CardPreviewProps {
  variant?: CardPreviewVariant;
  sectionTitle?: string;
  imageUrl?: string;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  link: Link;
  asLink?: "a" | React.ComponentType<any>;
  topic?: string;
  date?: string;
}

export const CardPreview: React.FC<CardPreviewProps> = ({
  variant = CardPreviewVariant.WITH_TOPIC_DATE,
  sectionTitle = "",
  imageUrl,
  title,
  description,
  link,
  asLink,
  date,
  topic,
}) => {
  const LinkComponent = asLink ?? "a";
  const titleAriaLabel =
    typeof title === "string" ? `${link.title} - ${title}` : link.title;

  return (
    <section className="card-preview-section">
      <SectionHeading
        title={sectionTitle}
        className="card-preview-section-title"
      />
      <div className="news-card">
        <div className="news-card__image">
          {imageUrl ? (
            <img src={imageUrl} alt="Anteprima" />
          ) : (
            <div className="placeholder-icon">
              <Image width={20} height={20} />
            </div>
          )}
        </div>
        {variant === CardPreviewVariant.WITH_TOPIC_DATE && (topic || date) && (
          <div className="news-card__info">
            <div className="news-card__info__topic">{topic ? topic : ""}</div>
            <div className="news-card__info__date">{date ? date : ""}</div>
          </div>
        )}
        <div className="news-card__content">
          <h3 className="news-card__title cursor-pointer hover-underline">
            <LinkComponent
              className="link-unstyled"
              href={link.link}
              aria-label={titleAriaLabel}
            >
              {title}
            </LinkComponent>
          </h3>
          <div className="news-card__description">
            <RichText description={description}></RichText>
          </div>
          <ArrowLink
            className="news-card__cta"
            href={link.link}
            asLink={asLink}
            aria-label={titleAriaLabel}
          >
            {link.title}
          </ArrowLink>
        </div>
      </div>
    </section>
  );
};
